<app-item class="rounded-border-box" [class.active]="!readOnly" (click)="controlClicked($event)">
    <app-item-label class="no-events validation-label">{{label}}</app-item-label>
    <app-item-value class="no-events" [value]="value?.fullname" [placeholder]="placeholderValue"></app-item-value>
</app-item>